import { render, staticRenderFns } from "./CreateNews.vue?vue&type=template&id=4dc486ee&scoped=true&"
import script from "./CreateNews.vue?vue&type=script&lang=js&"
export * from "./CreateNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc486ee",
  null
  
)

export default component.exports